// src/resources/batch-answer/ShouldMockBatchAnswer.ts
var e = (e) => e !== !1;
export { e as shouldMockBatchAnswer };

//# sourceMappingURL=ShouldMockBatchAnswer.js.map